import React, { useState, useEffect } from 'react';
import './StartSessionForm.css';

const inputTypes = { Name: 'name', 'Date of Birth': 'dob', Email: 'email' };

function StartSessionForm({
  environmentOptions,
  sessionTypeOptions,
  countryOptions,
  onSubmit,
  onSelectEnvironment,
}) {
  const [environment, setEnvironment] = useState('');
  const [sessionType, setSessionType] = useState('');
  const [country, setCountry] = useState('');
  const [amount, setAmount] = useState('');
  const [customerFirstname, setCustomerFirstname] = useState('');
  const [customerLastname, setCustomerLastname] = useState('');
  const [customerDob, setCustomerDob] = useState('');
  const [customerZip, setCustomerZip] = useState('');
  const [customerEmail, setCustomerEmail] = useState('');

  const [inputType, setInputType] = useState('');

  useEffect(() => {
    if (sessionType === 'DEPOSIT') return;
    setAmount('');
  }, [sessionType]);

  const handleSubmit = event => {
    event.preventDefault();
    onSubmit({
      environment,
      sessionType,
      country,
      amount: Number(amount),
      customerFirstname,
      customerLastname,
      customerDob,
      customerZip,
      customerEmail,
    });
  };

  // Need to load countries based on environment so passing the value up to
  // the parent component which will do the fetching.
  const onChangeEnvironment = e => {
    setEnvironment(e.target.value);
    onSelectEnvironment(e.target.value);
  };

  return (
    <div className="d-flex justify-content-center align-items-center profile-container">
      <div className="border p-4 bg-white shadow rounded">
        <h1 className="mb-4">Brite Test System</h1>
        <p>
          Begin a test session by choosing your environment, session type,
          country, and amount.
        </p>
        <form onSubmit={handleSubmit}>
          <div className="mb-3">
            <select
              data-testid="environment"
              className="form-select"
              onChange={e => onChangeEnvironment(e)}
            >
              <option value="">Select Environment</option>
              {environmentOptions?.map(
                o =>
                  (
                    <option key={o} value={o}>
                      {o}
                    </option>
                  ) ?? []
              )}
            </select>
          </div>
          <div className="mb-3">
            <select
              className="form-select"
              data-testid="sessionType"
              value={sessionType}
              onChange={e => setSessionType(e.target.value)}
            >
              <option value="">Select Session Type</option>
              {sessionTypeOptions?.map(
                o =>
                  (
                    <option key={o} value={o}>
                      {o}
                    </option>
                  ) ?? []
              )}
            </select>
          </div>
          <div className="mb-3">
            <select
              className="form-select"
              data-testid="country"
              value={country}
              onChange={e => setCountry(e.target.value)}
            >
              <option value="">Select Country</option>
              {countryOptions?.map(
                o =>
                  (
                    <option key={o} value={o}>
                      {o}
                    </option>
                  ) ?? []
              )}
            </select>
          </div>
          {sessionType === 'IDEAL' && (
            <div className="mb-3">
              <input
                data-testid="amount"
                type="number"
                className="form-control"
                placeholder="Amount"
                value={amount}
                onChange={e => setAmount(e.target.value)}
              />
            </div>
          )}
          {sessionType === 'DEPOSIT' && (
            <>
              <div className="mb-3">
                <select
                  data-testid="depositInputType"
                  className="form-select"
                  onChange={e => setInputType(inputTypes[e.target.value])}
                >
                  <option value="">Select Input Type</option>
                  {Object.keys(inputTypes).map(
                    o =>
                      (
                        <option key={o} value={o}>
                          {o}
                        </option>
                      ) ?? []
                  )}
                </select>
              </div>

              <div className="mb-3">
                <input
                  data-testid="amount"
                  type="number"
                  className="form-control"
                  placeholder="Amount"
                  value={amount}
                  onChange={e => setAmount(e.target.value)}
                />
              </div>
              {inputType === 'name' && (
                <>
                  <div className="mb-3">
                    <input
                      data-testid="customer_firstname"
                      type="string"
                      className="form-control"
                      placeholder="Customer First Name"
                      value={customerFirstname}
                      onChange={e => setCustomerFirstname(e.target.value)}
                    />
                  </div>

                  <div className="mb-3">
                    <input
                      data-testid="customer_lastname"
                      type="string"
                      className="form-control"
                      placeholder="Customer Last Name"
                      value={customerLastname}
                      onChange={e => setCustomerLastname(e.target.value)}
                    />
                  </div>

                  <div className="mb-3">
                    <input
                      data-testid="customer_zip"
                      type="string"
                      className="form-control"
                      placeholder="Customer Postal Code"
                      value={customerZip}
                      onChange={e => setCustomerZip(e.target.value)}
                    />
                  </div>
                </>
              )}
              {inputType === 'dob' && (
                <>
                  <div className="mb-3">
                    <input
                      data-testid="customer_dob"
                      type="date"
                      className="form-control"
                      placeholder="Customer Date of Birth"
                      value={customerDob}
                      onChange={e => setCustomerDob(e.target.value)}
                    />
                  </div>

                  <div className="mb-3">
                    <input
                      data-testid="customer_zip"
                      type="string"
                      className="form-control"
                      placeholder="Customer Postal Code"
                      value={customerZip}
                      onChange={e => setCustomerZip(e.target.value)}
                    />
                  </div>
                </>
              )}
              {inputType === 'email' && (
                <>
                  <div className="mb-3">
                    <input
                      data-testid="customer_email"
                      type="string"
                      className="form-control"
                      placeholder="Customer Email"
                      value={customerEmail}
                      onChange={e => setCustomerEmail(e.target.value)}
                    />
                  </div>
                </>
              )}
            </>
          )}
          <button
            disabled={
              !(
                environment &&
                environment !== '' &&
                sessionType &&
                sessionType !== '' &&
                country &&
                country !== '' &&
                (sessionType !== 'DEPOSIT' ||
                  (amount &&
                    amount !== '' &&
                    inputType === 'name' &&
                    customerFirstname !== '' &&
                    customerLastname !== '' &&
                    customerZip !== '') ||
                  (inputType === 'email' && customerEmail !== '') ||
                  (inputType === 'dob' &&
                    customerDob !== '' &&
                    customerZip !== ''))
              )
            }
            type="submit"
            className="btn btn-primary w-100"
          >
            Start session
          </button>
        </form>
      </div>
    </div>
  );
}

export default StartSessionForm;
